'use client';

// @spec authentication-reauth

import { useUrlErrorParam } from '@client/hooks/use-url-error-param';
import { useSession } from 'next-auth/react';

/**
 * Fallback error display for `?error=AccountMismatch` when the user is NOT
 * authenticated. When authenticated, GoogleReauthBanner handles the error
 * with richer context (user email, "Try Again" button).
 *
 * Mounted in the root layout (outside AuthenticatedLayout) so it renders
 * even when the session is missing — e.g., if a wrong-account OAuth attempt
 * somehow invalidated the session.
 */
export function AccountMismatchError() {
  const { status } = useSession();
  // Only act as fallback when unauthenticated — the auth-aware banner handles it otherwise
  const precondition = () => status !== 'loading' && status !== 'authenticated';
  const show = useUrlErrorParam('AccountMismatch', precondition);

  if (!show) return null;

  return (
    <div className="bg-red-600 text-white px-8 py-2 text-sm">
      <div className="max-w-4xl mx-auto text-center">
        Wrong Google account. Please sign in with the account you originally used.
      </div>
    </div>
  );
}
